import { render, staticRenderFns } from "./PageWarningsOrderBox.vue?vue&type=template&id=8e924c92&scoped=true"
import script from "./PageWarningsOrderBox.vue?vue&type=script&lang=js"
export * from "./PageWarningsOrderBox.vue?vue&type=script&lang=js"
import style0 from "./PageWarningsOrderBox.vue?vue&type=style&index=0&id=8e924c92&prod&scoped=true&lang=css"
import style1 from "./PageWarningsOrderBox.vue?vue&type=style&index=1&id=8e924c92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e924c92",
  null
  
)

export default component.exports